/**
 * Function 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <FunctionIcon className="w-8 h-8" />
 * <FunctionIcon className="w-12 h-12" />
 * ```
 */
export function FunctionIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Function icon"
      role="img"
    >
      <title>Function</title>
      <g id="Function">
        <path
          id="Vector"
          d="M30 28.0713H26.3316L24.2367 24.7349L22.084 28.0713H18.4895L22.3582 22.4922L18.5508 16.9285H22.2185L24.2792 20.1978L26.3512 16.9285H29.9568L26.1402 22.4167L30 28.0713ZM19.6025 7.3349H19.0588C18.7576 7.22619 18.4505 7.13934 18.1392 7.0749C17.7687 6.99001 17.3915 6.94622 17.0132 6.94417C16.3212 6.90415 15.6372 7.12522 15.0718 7.5717C14.5024 8.18506 14.1643 9.01723 14.1264 9.89868L13.8268 12.3345H18.1356V15.6675H13.2278L12.3505 22.0694C12.2083 23.3141 11.8417 24.5139 11.2725 25.5966C10.809 26.4382 10.1847 27.1556 9.44403 27.6976C8.77025 28.1688 8.02961 28.5093 7.25364 28.7045C6.43593 28.9059 5.60061 29.005 4.76318 28.9998C4.33562 28.9998 3.84655 28.9737 3.29598 28.9215C2.85985 28.8926 2.42649 28.8249 2 28.7193V24.0003H2.27972C2.39074 24.1826 2.53741 24.3345 2.70871 24.4445C2.88 24.5546 3.07146 24.6199 3.26868 24.6356C3.65278 24.7228 4.0437 24.7673 4.4357 24.7684C5.19367 24.8179 5.94087 24.5499 6.53056 24.0169C7.11751 23.3172 7.46723 22.4113 7.51952 21.4553L8.28887 15.6678H4.93375V12.3345H9.11557L9.53282 9.31382C9.65323 8.16138 10.0073 7.05456 10.5683 6.0771C11.0315 5.30865 11.6359 4.65854 12.3415 4.16973C13.013 3.7079 13.7579 3.39396 14.5356 3.24494C15.2933 3.08812 16.062 3.00615 16.8327 3C17.29 3 17.7473 3.02156 18.2047 3.06469C18.662 3.10871 19.1279 3.17431 19.6025 3.26148L19.6025 7.3349Z"
          fill="black"
        />
      </g>
    </svg>
  );
}
